// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #1a1a1a;
}

.viewer-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.viewer-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
  gap: 24px;
}

.viewer-image {
  max-width: 100%;
  max-height: calc(100% - 60px);
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
}

.viewer-download-btn {
  flex-shrink: 0;
}

.viewer-office {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  padding: 32px;
  text-align: center;
}
.viewer-office__icon {
  font-size: 64px;
  color: rgba(255, 255, 255, 0.3);
}
.viewer-office__text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  max-width: 320px;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-viewer/document-viewer.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,+BAAA;AACJ;AAEE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ","sourcesContent":["ion-content {\n  --background: #1a1a1a;\n}\n\n.viewer-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.viewer-image-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 16px;\n  gap: 24px;\n}\n\n.viewer-image {\n  max-width: 100%;\n  max-height: calc(100% - 60px);\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);\n}\n\n.viewer-download-btn {\n  flex-shrink: 0;\n}\n\n.viewer-office {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n  padding: 32px;\n  text-align: center;\n\n  &__icon {\n    font-size: 64px;\n    color: rgba(255, 255, 255, 0.3);\n  }\n\n  &__text {\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 16px;\n    max-width: 320px;\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
